/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faBusAlt} from '@fortawesome/pro-duotone-svg-icons';

const TransportationIcon = ({icon, ...props}) => (
  <FontAwesomeIcon icon={faBusAlt} {...props} />
);

export default TransportationIcon;
